import { normalizePaginationPayload } from '@/composables/shared/usePagination';
import { extractPayload } from '@/utils/dataNormalization';

export const fetchSuppliersListPayload = async (suppliersService, params = {}, fallbackPagination = {}) => {
  const response = await suppliersService.index(params);
  const payload = extractPayload(response);
  const metrics = payload?.metrics && typeof payload.metrics === 'object' ? payload.metrics : null;

  return {
    data: Array.isArray(payload?.data) ? payload.data : [],
    pagination: normalizePaginationPayload(payload?.pagination, fallbackPagination),
    metrics,
  };
};
